import { render, staticRenderFns } from "./NewsListItem.vue?vue&type=template&id=4489bb77&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"
import style0 from "./NewsListItem.vue?vue&type=style&index=0&id=4489bb77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489bb77",
  null
  
)

export default component.exports